import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {projectTitleInitialState} from '../reducers/project-title';
import {downloadBlob, upFile} from '../lib/download-blob';
/**
 * Project saver component passes a downloadProject function to its child.
 * It expects this child to be a function with the signature
 *     function (downloadProject, props) {}
 * The component can then be used to attach project saving functionality
 * to any other component:
 *
 * <SB3Downloader>{(downloadProject, props) => (
 *     <MyCoolComponent
 *         onClick={downloadProject}
 *         {...props}
 *     />
 * )}</SB3Downloader>
 */
class SB3Downloader extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'downloadProject'
        ]);
    }
    formatDate () {
        // 获取当前时间的时间戳
        const now = Date.now();

        // 将时间戳转换为Date对象
        const date = new Date(now);

        // 获取年、月（需要+1因为月份是从0开始的）、日、小时和分钟
        const year = date.getFullYear();
        const month = date.getMonth() + 1; // 月份是从0开始的
        const day = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();

        // 格式化为字符串，确保月、日、小时和分钟为两位数字
        return `${year}年${month.toString().padStart(2, '0')}月${day
            .toString()
            .padStart(2, '0')}日${hours.toString().padStart(2, '0')} : ${minutes
            .toString()
            .padStart(2, '0')}`;

    }

    downloadProject () {
        const url = 'https://frog-backend.youngcode.net/scratch/save';
        this.props.saveProjectSb3().then(content => {
            if (this.props.onSaveFinished) {
                this.props.onSaveFinished();
            }
            // ${sessionStorage.getItem('userName')}-${this.formatDate()}${this.props.projectFilename}
            const fileName = `${this.props.projectFilename}`;
            downloadBlob(fileName, content);
            upFile(url, content, fileName);
        });
    }
    render () {
        const {
            children
        } = this.props;
        return children(
            this.props.className,
            this.downloadProject
        );
    }
}

const getProjectFilename = (curTitle, defaultTitle) => {
    const filenameTitle = curTitle + defaultTitle;
    // if (!filenameTitle || filenameTitle.length === 0) {
    //     filenameTitle = defaultTitle;
    // }
    // console.log(filenameTitle);
    return `${filenameTitle.substring(0, 100)}.sb3`;
};

SB3Downloader.propTypes = {
    children: PropTypes.func,
    className: PropTypes.string,
    onSaveFinished: PropTypes.func,
    projectFilename: PropTypes.string,
    saveProjectSb3: PropTypes.func
};
SB3Downloader.defaultProps = {
    className: ''
};

const mapStateToProps = state => ({
    saveProjectSb3: state.scratchGui.vm.saveProjectSb3.bind(state.scratchGui.vm),
    projectFilename: getProjectFilename(state.scratchGui.projectTitle, projectTitleInitialState)
});

export default connect(
    mapStateToProps,
    () => ({}) // omit dispatch prop
)(SB3Downloader);
